import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { Types } from '@grandvisionhq/graphql';
import { Alert } from '@grandvisionhq/iris-ui';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/state';
import '../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import '../../../StepShipping/selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/icons';
import '@grandvisionhq/locations';
import '../../../StepShipping/modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import '../../../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/utils';
import '../../../mappers/errors-mapping.js';
import '../../../models/cart/cart-state.js';
import '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import '@grandvisionhq/payments';
import '@grandvisionhq/api-client';
import '@grandvisionhq/auth';
import '../../../selectors.js';
import '@grandvisionhq/lib-utils-cart';
import '../../../operations/mutations/set-customer-details.js';
import '../../../operations/mutations/set-shipping-method.js';
import '../../../operations/mutations/set-shipping-state.js';
import '../../../operations/mutations/set-store.js';
import '../../../operations/mutations/create-apple-pay-session.js';
import '../../../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import '../../../utils/get-customer-details-payload.js';
import 'history';
import '../../../utils/has-cart-errors.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../../operations/fragments/checkout-mutation-result.js';
import '../../../operations/fragments/cart-mutation-failures.js';
import '../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../operations/fragments/paypal-payment.js';
import '../../../operations/fragments/saved-user-details.js';
import '../../../operations/queries/get-checkout-state.js';
import '../../../operations/queries/get-user-details.js';
import '@grandvisionhq/shipping';
import '@grandvisionhq/forms';
import '../../../state.js';
import '@grandvisionhq/lib-utils-html';
import 'classnames';
import '../../../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import 'motion/react';
import '../../../slots/forms/form-context.js';
import '../../../slots/summaries/summary-context.js';
import '../../../slots/summaries/types.js';
import '../../../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import { OrderCallToActionContainer } from '../../../modules/OrderCallToAction/containers/OrderCallToActionContainer.js';
import { OrderConfirmDonation } from '../OrderConfirmDonation/OrderConfirmDonation.js';

const OrderConfirmHeroBanner = ({ labels , contains , orderNumber , paymentStatus , paymentMethod , donationIntent  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-confirm-hero-banner"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-confirm-hero-banner__content"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, labels.title), paymentStatus == 'PENDING' && paymentMethod == Types.OrderPaymentMethod.MOBILEPAY ? /*#__PURE__*/ React.createElement(Alert, {
        variant: "warning",
        title: labels.orderPending.title,
        className: "alert-m-default"
    }, labels.orderPending.message) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", null, labels.completed, orderNumber && /*#__PURE__*/ React.createElement("strong", null, " ", orderNumber)), /*#__PURE__*/ React.createElement(Alert, {
        variant: "success",
        title: labels.orderPlaced.title,
        className: "alert-m-default"
    }, labels.orderPlaced.message), donationIntent && /*#__PURE__*/ React.createElement(OrderConfirmDonation, {
        foundationKey: donationIntent.foundationKey
    })), contains.prescriptionGlasses && /*#__PURE__*/ React.createElement("p", null, labels.orderContainsPrescriptionGlasses), contains.regular && /*#__PURE__*/ React.createElement("p", null, labels.orderContainsSunglasses), /*#__PURE__*/ React.createElement(OrderCallToActionContainer, {
        isStacked: true
    })));
};

export { OrderConfirmHeroBanner };
//# sourceMappingURL=OrderConfirmHeroBanner.js.map
